import Vue from 'vue'
import {Picker} from 'mint-ui'
Vue.component(Picker.name,Picker);



// WEBPACK FOOTER //
// ./src/mint-ui/index.js